export default {
  title: 'Bestelindeling',
  form: {
    show_hero_image_with_offers: {
      label: 'Hero-afbeelding met aanbiedingen tonen',
      description:
        'Standaard verbergt het toevoegen van een aanbiedingsafbeelding de hero-afbeelding. Schakel dit in om beide te tonen.',
    },
  },
  buttons: {
    save: 'Opslaan',
  },
  toasts: {
    failed_to_save_changes: 'Wijzigingen opslaan mislukt',
    changes_got_saved: 'Wijzigingen opgeslagen',
  },
};
